import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  createInvite(_, userId) {
    return axios.put(`/api/invites/${userId}`)
  },
}
